"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FooterAbout = void 0;

var _atoms = require("../../atoms");

var _FooterSocials = require("./FooterSocials");

var _jsxRuntime = require("react/jsx-runtime");

var FooterAbout = function FooterAbout() {
  return (0, _jsxRuntime.jsxs)(_atoms.Flex, {
    height: "100%",
    width: {
      _: '100%',
      lg: '20%'
    },
    flexDirection: "column",
    alignItems: {
      _: 'center',
      lg: 'flex-start'
    },
    order: 0,
    children: [(0, _jsxRuntime.jsx)(_atoms.Logo, {
      white: true,
      width: "152px"
    }), (0, _jsxRuntime.jsx)(_atoms.Body, {
      variant: "small",
      color: "white",
      mt: "13px",
      width: {
        _: '80%',
        lg: 'auto'
      },
      textAlign: {
        _: 'center',
        lg: 'left'
      },
      children: "MyCrypto is an open-source tool that allows you to manage your Ethereum accounts privately and securely. Developed by and for the community since 2015, we\u2019re focused on building awesome products that put the power in people\u2019s hands."
    }), (0, _jsxRuntime.jsxs)(_atoms.Box, {
      display: {
        _: 'none',
        lg: 'block'
      },
      children: [(0, _jsxRuntime.jsx)(_FooterSocials.FooterSocials, {}), (0, _jsxRuntime.jsx)(_atoms.Body, {
        variant: "small",
        color: "white",
        mt: "16px",
        children: "\xA9 ".concat(new Date().getFullYear(), " MyCrypto, Inc.")
      })]
    })]
  });
};

exports.FooterAbout = FooterAbout;